import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Switch } from '@/components/ui/switch';
import { Receipt, Save, CheckCircle2, XCircle } from 'lucide-react';

export function AccountingEmailCard({ accountingConfig, setAccountingConfig, onSave, saving }) {
  return (
    <Card className="border-border bg-card">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-lg flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
              <Receipt className="w-5 h-5 text-emerald-500" />
              Email Contabilita'
              {accountingConfig.configured ? (
                <span className="ml-2 flex items-center text-xs text-green-500">
                  <CheckCircle2 className="w-3 h-3 mr-1" /> Configurato
                </span>
              ) : (
                <span className="ml-2 flex items-center text-xs text-yellow-500">
                  <XCircle className="w-3 h-3 mr-1" /> Non configurato
                </span>
              )}
            </CardTitle>
            <CardDescription>
              Ricevi una notifica email per ogni acquisto con i dettagli di fatturazione del cliente
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-2">
          <Label>Email Contabilita' *</Label>
          <Input
            data-testid="accounting-email"
            type="email"
            placeholder="contabilita@tuazienda.com"
            value={accountingConfig.accounting_email || ''}
            onChange={(e) => setAccountingConfig({ ...accountingConfig, accounting_email: e.target.value })}
          />
          <p className="text-xs text-muted-foreground">
            Questa email ricevera' una notifica per ogni pagamento completato con i dettagli del cliente
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Switch
            id="notify-purchase"
            checked={accountingConfig.notify_on_purchase}
            onCheckedChange={(checked) => setAccountingConfig({ ...accountingConfig, notify_on_purchase: checked })}
            data-testid="notify-on-purchase"
          />
          <Label htmlFor="notify-purchase" className="cursor-pointer">
            Abilita notifiche per ogni acquisto
          </Label>
        </div>

        <div className="p-3 bg-muted/30 rounded-lg border border-border">
          <p className="text-sm text-muted-foreground">
            <strong>Contenuto email:</strong> Ogni notifica includera' l'importo, il tipo di acquisto (abbonamento o ticket) e i dati di fatturazione inseriti dall'utente.
          </p>
        </div>

        <Separator />

        <Button
          onClick={onSave}
          disabled={saving}
          data-testid="save-accounting-config"
          className="bg-primary text-primary-foreground hover:bg-primary/90"
        >
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Salvataggio...' : 'Salva Email Contabilita\''}
        </Button>
      </CardContent>
    </Card>
  );
}
